<div class="matrix-wrapper">
  <div
    id="main-origin-destination-container-root"
  ></div>

  <div class="palette-buttons">
    <div
      class="palette-option red"
      [class.active]="colorSetName === 'red'"
      title="{{ 'app.origin-destination.palette-buttons.red' | translate }}"
      (click)="onChangePalette('red')"
    ></div>
    <div
      class="palette-option blue"
      [class.active]="colorSetName === 'blue'"
      title="{{ 'app.origin-destination.palette-buttons.blue' | translate }}"
      (click)="onChangePalette('blue')"
    ></div>
    <div
      class="palette-option orange"
      [class.active]="colorSetName === 'orange'"
      title="{{ 'app.origin-destination.palette-buttons.orange' | translate }}"
      (click)="onChangePalette('orange')"
    ></div>
    <div
      class="palette-option gray"
      [class.active]="colorSetName === 'gray'"
      title="{{ 'app.origin-destination.palette-buttons.gray' | translate }}"
      (click)="onChangePalette('gray')"
    ></div>

    <div class="color-by-selector">
      <label>
        <input
          type="radio"
          name="colorBy"
          value="totalCost"
          [checked]="colorBy === 'totalCost'"
          (change)="onChangeColorBy('totalCost')"
        />
        {{ 'app.origin-destination.color-by-selector.total-cost' | translate }}
      </label>
      <label>
        <input
          type="radio"
          name="colorBy"
          value="travelTime"
          [checked]="colorBy === 'travelTime'"
          (change)="onChangeColorBy('travelTime')"
        />
        {{ 'app.origin-destination.color-by-selector.travel-time' | translate }}
      </label>
      <label>
        <input
          type="radio"
          name="colorBy"
          value="transfers"
          [checked]="colorBy === 'transfers'"
          (change)="onChangeColorBy('transfers')"
        />
        {{ 'app.origin-destination.color-by-selector.transfers' | translate }}
      </label>
    </div>
  </div>

  <sbb-radio-group class="sbb-checkbox-group-horizontal" [(ngModel)]="displayBy">
    <sbb-radio-button value="totalCost" (change)="onChangeDisplayBy('totalCost')">
      {{ 'app.origin-destination.display-by-selector.total-cost' | translate }}
    </sbb-radio-button>
    <sbb-radio-button value="travelTime" (change)="onChangeDisplayBy('travelTime')">
      {{ 'app.origin-destination.display-by-selector.travel-time' | translate }}
    </sbb-radio-button>
    <sbb-radio-button value="transfers" (change)="onChangeDisplayBy('transfers')">
      {{ 'app.origin-destination.display-by-selector.transfers' | translate }}
    </sbb-radio-button>
  </sbb-radio-group>
</div>
